import React from 'react';
import Select from 'react-select';
import {
  FaSearch,
  FaSortAlphaDown,
  FaSortAlphaUp
} from 'react-icons/fa';
import { RotateCcw } from 'lucide-react';
import './Subheader.css';

const DEFAULT_QUERY_PARAMS = {
  page: 1,
  filterField: null,
  filterValue: '',
  sortBy: '',
  sortOrder: 'asc',
  hospitalFilter: [],
  labelFilter: [],
  statusFilter: [],
  boardStatusFilter: [],
  expiringOnly: false,
  hideClean: false,
  open30plus: false,
};

const Subheader = ({
  queryParams,
  setQueryParams,
  total,
  limit,
  hospitalList,
}) => {
  const { page, sortBy, sortOrder, filterValue, hospitalFilter } = queryParams;

  const hasActiveFilters =
  queryParams.filterValue ||
  queryParams.sortBy ||
  queryParams.sortOrder !== 'asc' ||
  (queryParams.hospitalFilter || []).length > 0 ||
  (queryParams.labelFilter || []).length > 0 ||
  (queryParams.statusFilter || []).length > 0 || 
  (queryParams.boardStatusFilter || []).length > 0 ||
  queryParams.expiringOnly ||
  queryParams.hideClean ||
  queryParams.open30plus;

  const setPage = (newPage) => {
    setQueryParams((prev) => ({ ...prev, page: newPage }));
  };

  return (
    <div className="subheader-wrapper">
      <div className="subheader">
      <div className="subheader-section search">
        <FaSearch />

        <input
          type="text"
          placeholder="Search..."
          value={filterValue || ''}
          onChange={(e) =>
            setQueryParams((prev) => ({
              ...prev,
              filterValue: e.target.value,
              filterField: e.target.value ? 'search_all' : null,
              page: 1,
            }))
          }
        />

        {filterValue && (
          <button
            className="clear-search-btn"
            type="button"
            aria-label="Clear search"
            onClick={() =>
              setQueryParams((prev) => ({
                ...prev,
                filterValue: '',
                filterField: null,
                page: 1,
              }))
            }
          >
            ×
          </button>
        )}
      </div>

        <Select
          isMulti
          closeMenuOnSelect={false}
          placeholder="Filter hospitals..."
          options={hospitalList.map((h) => ({ label: h, value: h }))}
          value={(hospitalFilter || []).map((h) => ({ label: h, value: h }))}
          onChange={(selected) =>
            setQueryParams((prev) => ({
              ...prev,
              hospitalFilter: selected.map((s) => s.value),
              page: 1,
            }))
          }
          className="multi-select"
          classNamePrefix="custom-select"
        />

        <div className="subheader-section sort-control">
          <label className="sort-label" htmlFor="sort-select">
            Sort by:
          </label>
          <div className="sort-select-group">
            <select
              id="sort-select"
              value={sortBy}
              onChange={(e) =>
                setQueryParams((prev) => ({
                  ...prev,
                  sortBy: e.target.value,
                  page: 1,
                }))
              }
            >
              <option value="">Select...</option>
              <option value="patient_name">Patient Name  </option>
              <option value="check_in_at">Check In Date  </option>
              <option value="hospital_shortname">Hospital  </option>
            </select>
            <button
              onClick={() =>
                setQueryParams((prev) => ({
                  ...prev,
                  sortOrder: prev.sortOrder === 'asc' ? 'desc' : 'asc',
                  page: 1,
                }))
              }
              title="Toggle sort direction"
            >
              {sortOrder === 'asc' ? <FaSortAlphaDown /> : <FaSortAlphaUp />}
            </button>
          </div>
        </div>

        {hasActiveFilters && (
          <div className="subheader-section reset">
            <button
              className="reset-filters-btn"
              onClick={() => setQueryParams(DEFAULT_QUERY_PARAMS)}
              title="Clear all filters"
              type="button"
            >
              <RotateCcw size={16} />
              Reset Filters
            </button>
          </div>
        )}

        <div className="subheader-section pagination">
          <button onClick={() => setPage(Math.max(page - 1, 1))} disabled={page <= 1}>
            Prev
          </button>

          <span>
            Page {page} of {Math.ceil(total / limit)} ({total} total)
          </span>

          <button
            onClick={() => {
              const maxPage = Math.ceil(total / limit);
              if (page < maxPage) setPage(page + 1);
            }}
            disabled={page >= Math.ceil(total / limit)}
          >
            Next
          </button>
        </div>
      </div>

    </div>
  );
};

export default Subheader;
